const itemKey = "loginInfo_1";
let writeLoginState = function(data){
    if(!(data && data.AccessToken && data.ExpireSpan))
    {
        console.log("saveState参数格式不正确");
        return;
    }
    data.endTime = new Date().getTime()+data.ExpireSpan*1000;
    //localStorage.clear();
    localStorage.setItem(itemKey,JSON.stringify(data));
    
}

let readLoginState = function(){
    let v = localStorage.getItem(itemKey);
    if(!v)
    {
        return null;
    }
    let obj = JSON.parse(v);
    if(obj.endTime <= new Date().getTime())
    {
        localStorage.removeItem(itemKey);
        return null;
    }
    return obj;
}

let removeLoginState = function(){
    localStorage.removeItem(itemKey);
}
/////////
let setLoginState = function(data){
    if(data)
    {
        if(data.MergedRole && data.MergedRole.Permissions)
        {
            data.MergedRole.PermissionsObj ={};
            data.MergedRole.Permissions.forEach(element => {
                if(element.ActionKey)
                {
                    data.MergedRole.PermissionsObj[element.ActionKey.toLowerCase()] = true;
                }
            });
            delete data.MergedRole.Permissions;
        }
        writeLoginState(data);
    }
    else
    {
        removeLoginState();
    }
    window[itemKey] = data;
}

let getLoginState = function(){
    let state = window[itemKey];
    if(!state)
    {
        state = readLoginState();
        window[itemKey] = state;
    }
    return state;
    
}
////////
let login = function(data){
    setLoginState(data);
    if(window.rootVue)
    {
        window.rootVue.$router.push('/Home')
    }
    else
    {
        console.log("login时无window.rootVue");
    }
}

let logout = function(){
    setLoginState(null);
    if(window.rootVue)
    {
        window.rootVue.$router.push('/Login')
    }
    else
    {
        console.log("logout时无window.rootVue");
    }
}

let loginCheck = function(){
    if(getLoginState())
    {
        return;
    }
    if(window.rootVue)
    {
        window.rootVue.$router.push('/Login')
    }
    else
    {
        window.location.href="#/Login";
        console.log("loginCheck时无window.rootVue");
    }
}

let getAccessToken = function()
{
    let v = getLoginState();
    if(v)
    {
        return v.AccessToken;
    }
    return null;
}

let getUserName = function()
{
    let v = getLoginState();
    if(v)
    {
        return v.UserName;
    }
    return null;
}

let getUserID = function()
{
    let v = getLoginState();
    if(v)
    {
        return v.UserID;
    }
    return null;
}

let hasPermission = function(actionKey)
{
    if(!actionKey)
        return true;

    actionKey = actionKey.toLowerCase();
    let r = getLoginState();
    if(r)
    {
        if(r.IsAdmin)
        {
            return true;
        }
        if(r.MergedRole)
        {
            if(r.MergedRole.IsAdmin)
            {
                return true;
            }
            if(r.MergedRole.PermissionsObj)
            {
                if(r.MergedRole.PermissionsObj[actionKey])
                    return true;
                else
                    return false;
            }
        }
    }

    return false;
}

export default{
    setLoginState,
    getLoginState,
    login,
    logout,
    loginCheck,
    getAccessToken,
    getUserID,
    getUserName,
    hasPermission,
}


// WEBPACK FOOTER //
// ./src/common/sessionMgr.js